import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BaseComponent } from '@wms/components';
import { VariableCrudManagerService, BaseVariableService, VariablesTemplateComponent } from '@wms/variables';
import { TooltipModule } from 'ngx-bootstrap/tooltip';

@Component({
  selector: 'wms-device-var-creation',
  standalone: true,
  imports: [
    CommonModule,
    VariablesTemplateComponent,
    TooltipModule
  ],
  templateUrl: './device-var-creation.component.html',
  styleUrls: []
})
export class DeviceVarCreationComponent extends BaseComponent implements OnInit {
  @Input() selectedVarService: any;

  constructor(public varManagerService: VariableCrudManagerService, public baseVariableService: BaseVariableService) {
    super();
   }

  ngOnInit(): void {
  }

  handleModelChange(changeObj: any) {
    this.baseVariableService.selectedVariable.propertyObj[changeObj.propertyName].modelObj[this.baseVariableService.selectedVariable.propertyObj[changeObj.propertyName].modelKey] = changeObj.$event;  
    this.selectedVarService.__onPropertyChange(changeObj.propertyName, changeObj.$event);
  }
}
